import React from 'react'
import PropTypes from 'prop-types'
import {Table, Column, Cell} from 'components/Table'
import Checkbox from 'components/Checkbox'

export default class EditDomainForm extends React.Component {
  static propTypes = {
    internalWhitelistRegexes: PropTypes.array,
    onRemoveRegexes: PropTypes.func.isRequired
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedMappings: []
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedMappings: []
    })
  }

  render() {
    const {internalWhitelistRegexes} = this.props
    const {selectedMappings} = this.state
    const disabled = selectedMappings.length === 0
    const data = internalWhitelistRegexes.map(item => {
      return {
        regex: item
      }
    })

    return (
      <form
        className='settings-categories-view_edit-form'
        onSubmit={this.handleSubmit}
      >
        <Table data={data} empty='No internal whitelist regexes for selected'>
          <Column
            header='Internal whitelist regex'
            grow
            cell={data => <Cell>{data.regex}</Cell>}
          />
          <Column
            header='Select'
            width='100px'
            className='is-checkbox'
            cell={data => {
              return (
                <Cell className='is-checkbox'>
                  <Checkbox
                    checked={selectedMappings.includes(data.regex)}
                    onChange={checked => this.onSelect(data.regex, checked)}
                  />
                </Cell>
              )
            }}
          />
        </Table>
        <div className='settings-categories-view_edit-form_button'>
          <button className='is-red' disabled={disabled} type='submit'>
            Remove Selected
          </button>
        </div>
      </form>
    )
  }

  onSelect = (id, checked) => {
    const {selectedMappings} = this.state

    if (checked) {
      this.setState({
        selectedMappings: !selectedMappings.includes(id)
          ? [...selectedMappings, id]
          : selectedMappings
      })
    } else if (selectedMappings.includes(id)) {
      const index = selectedMappings.findIndex(mapping => mapping === id)

      this.setState({
        selectedMappings: [
          ...selectedMappings.slice(0, index),
          ...selectedMappings.slice(index + 1)
        ]
      })
    }
  }

  handleSubmit = evt => {
    evt.preventDefault()
    const {onRemoveRegexes} = this.props
    const {selectedMappings} = this.state

    onRemoveRegexes(selectedMappings)
  }
}



// WEBPACK FOOTER //
// ./client/views/SettingsDomainView/EditDomainForm.js